<template>
  <div>
    <div class="bonus_offer_area account_area">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title">
            {{ $t('Bao.event') }}
          </h5>
          <button class="account_btn_get" @click="clickToogleAccountQuick()">
            <span class="text">{{ selectedGameTypeName }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="18"
              viewBox="0 0 20 18"
              class="icon"
            >
              <g
                id="组_1755"
                data-name="组 1755"
                transform="translate(-363 -150)"
              >
                <rect
                  id="矩形_1303"
                  data-name="矩形 1303"
                  width="20"
                  height="4"
                  transform="translate(363 150)"
                  fill="#f7a01b"
                />
                <rect
                  id="矩形_1304"
                  data-name="矩形 1304"
                  width="16"
                  height="4"
                  transform="translate(367 157)"
                  fill="#f7a01b"
                />
                <rect
                  id="矩形_1305"
                  data-name="矩形 1305"
                  width="12"
                  height="4"
                  transform="translate(371 164)"
                  fill="#f7a01b"
                />
              </g>
            </svg>
          </button>
          <div class="position-relative">
            <div class="quick_btn_wrap pc">
              <ul class="quick_btn_area eight list-unstyled">
                <li>
                  <button v-if="selectedGameType == 'all'" class="btn btn_quick d-flex align-items-center justify-content-center w-100 active" @click="clickGameType('all')">
                    {{ $t("Bao.all") }}
                  </button>
                  <button v-else class="btn btn_quick d-flex align-items-center justify-content-center w-100" @click="clickGameType('all')">
                    {{ $t("Bao.all") }}
                  </button>
                </li>
                <li v-for="(item, key) in gameType" :key="key">
                  <button v-if="item.game_type == gameType" class="btn btn_quick d-flex align-items-center justify-content-center w-100 active" @click="clickGameType(item.game_type)">
                    {{ item.name }}
                  </button>
                  <button v-else class="btn btn_quick d-flex align-items-center justify-content-center w-100" @click="clickGameType(item.game_type)">
                    {{ item.name }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <template v-if="list.length === 0 && !loading && !firstLoad">
            <div class="no_data_area h-100 d-grid vh-100">
              <div
                class="no_data_inner d-flex flex-column align-items-center justify-content-center text-center"
              >
                <img class="mb-10" src="@/assets/images/no_record_data.png" alt="">
                <h5 class="mt-0">
                  <b>{{ $t("Bao.no_relevant_data_records") }}</b>
                </h5>
                <h6 class="mb-0">
                  {{ $t("Bao.search_results_are_empty") }}
                </h6>
              </div>
            </div>
          </template>
          <template v-else>
            <ul class="bonus_offer_list d-grid list-unstyled mb-0">
              <li v-for="(item, key) in list" :key="key">
                <a class="card bonus_offer_card border-0 p-0">
                  <div class="picture">
                    <picture @click="goMore(item.id)">
                      <img class="img d-block d-md-none" :src="item.image_mobile" alt="">
                      <img class="img d-none d-md-block" :src="item.image_small" alt="">
                    </picture>
                  </div>
                  <div class="inverted-border-radius">
                    <div class="info">
                      <div class="text">
                        <p>Time: {{ item.start_at | dateFormat }}~{{ item.end_at | dateFormat }}</p>
                        <p>Condition: {{ item.vip_level_text.join(', ') }}</p>
                      </div>
                      <div class="btn" :class="disabledClass(item.status)" :disabled="actionLoading" @click="clickAction(item)">
                        <p class="">{{ item.status_text }}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </template>
          <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
        </div>
      </div>
    </div>
    <div v-show="showAccountQuick" class="account_quick">
      <div class="btn_done">
        <button class="btn_cross" @click="closeAccountQuick()">
          Done
        </button>
      </div>
      <ul class="list_info list-unstyled">
        <li>
          <a class=" " @click="clickGameType('all')">{{ $t("Bao.all") }}</a>
        </li>
        <li v-for="(item, key) in gameType" :key="key">
          <a class=" " @click="clickGameType(item.game_type, item.name)">{{ item.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getTypeMenuInfo } from '@/api/game'
import { getEvent, joinEvent, receive } from '@/api/event'
import { showNotice, detectMob } from '@/utils/tool'
import { logout } from '@/utils/user'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    ScrollLoader
  },
  data() {
    return {
      actionLoading: false,
      list: null,
      page: 1,
      pageSize: 50,
      enableAutoLoad: true,
      loading: false,
      firstLoad: true,
      gameType: [],
      selectedGameType: 'all',
      selectedGameTypeName: this.$i18n.t('Bao.all'),
      showAccountQuick: false
    }
  },
  async created() {
    if (this.$store.getters.gameType) {
      this.gameType = this.$store.getters.gameType
    } else {
      getTypeMenuInfo().then((response) => {
        this.$store.commit('SET_GAME_TYPE', response.data.data)
        this.gameType = response.data.data
      })
    }
    this.oneQuery()
  },
  methods: {
    clickGameType(game_type, game_type_name) {
      this.list = []
      this.selectedGameType = game_type
      if (game_type === 'all') {
        this.selectedGameTypeName = this.$i18n.t('Bao.all')
      } else {
        this.selectedGameTypeName = game_type_name
      }
      this.enableAutoLoad = true
      this.page = 1
      this.query()
      this.closeAccountQuick()
    },
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.selectedGameType !== 'all') {
        queryObj.game_type = this.selectedGameType
      }
      const res = await getEvent(queryObj)
      this.list = [...this.list, ...res.data.data.list]

      if (res.data.data.list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.enableAutoLoad = true
        this.page += 1
      }
      this.loading = false

      this.firstLoad = false
    },
    oneQuery() {
      this.disableAutoLoad = true
      this.page = 1
      this.list = []
      this.query()
    },
    disabledClass(status) {
      return [0, 1, 3, 5].indexOf(status) === -1 ? 'btn_over' : ''
    },
    clickAction(item) {
      if (this.actionLoading) {
        return
      }

      if (item.status === 0) {
        logout(this.$t('Bao.please_login_for_function'))
      } else if (item.status === 3) {
        this.actionLoading = item.id
        joinEvent(item.id)
          .then((response) => {
            showNotice(response.data.msg)
            this.query()
          })
          .catch((error) => {
            showNotice(error.response.data.msg)
          })
          .finally((e) => {
            this.actionLoading = false
          })
      } else if (item.status === 5) {
        this.actionLoading = item.id
        receive(item.event_member_id)
          .then((response) => {
            showNotice(response.data.msg)
            this.query()
          })
          .catch((error) => {
            showNotice(error.response.data.msg)
          })
          .finally((e) => {
            this.actionLoading = false
          })
      }
    },
    goMore(eventId) {
      if (this.$router.currentRoute.path.indexOf('/web') >= 0) {
        this.$router.push('/web/event/' + eventId)
      } else {
        this.$router.push('/event/' + eventId)
      }
    },
    goLogin() {
      if (!detectMob()) this.$bvModal.show('modal_login_box')
      else this.$router.push('/user/login')
    },
    isMobile() {
      return detectMob()
    },
    clickToogleAccountQuick() {
      this.showAccountQuick = !this.showAccountQuick
      this.$store.state.app.hideMobileNav = !this.$store.state.app.hideMobileNav
    },
    closeAccountQuick() {
      this.showAccountQuick = false
      this.$store.state.app.hideMobileNav = false
    }
  }
}
</script>
